import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MainPageComponent} from "./pages/main-page/main-page.component";
import {ArtistPageComponent} from "./pages/artist-page/artist-page.component";
import {MelodyPageComponent} from "./pages/melody-page/melody-page.component";
import {GenresPageComponent} from "./pages/genres-page/genres-page.component";
import {Page404Component} from "./pages/error-pages/page-404/page-404.component";
import {Page500Component} from "./pages/error-pages/page-500/page-500.component";
import {Page505Component} from "./pages/error-pages/page-505/page-505.component";
import {SubscriptionsPageComponent} from "./pages/subscriptions-page/subscriptions-page.component";
import {SubscriberMelodiesPageComponent} from "./pages/subscriber-melodies-page/subscriber-melodies-page.component";
import {SubscriberFavoritesComponent} from "./pages/subscriber-favorites/subscriber-favorites.component";
import {SubscriberRulesPageComponent} from "./pages/subscriber-rules-page/subscriber-rules-page.component";
import {authGuard} from "./guards/auth.guard";
import {MobileAppsPageComponent} from "./pages/mobile-apps-page/mobile-apps-page.component";
import {PrivacyPageComponent} from "./pages/privacy-page/privacy-page.component";
import {UssdCommandsPageComponent} from "./pages/ussd-commands-page/ussd-commands-page.component";
import {OfferPageComponent} from "./pages/offer-page/offer-page.component";
import {SubscriberUgcPageComponent} from "./pages/subscriber-ugc-page/subscriber-ugc-page.component";

const routes: Routes = [
  {path: '', component: MainPageComponent, pathMatch: 'full'},
  {path: 'artists/:id', component: ArtistPageComponent, pathMatch: 'full'},
  {path: 'melodies/:id', component: MelodyPageComponent, pathMatch: 'full'},
  {path: 'genres', component: GenresPageComponent, pathMatch: 'full'},
  {path: 'subscriber/subscriptions', component: SubscriptionsPageComponent, pathMatch: 'full', canActivate: [authGuard]},
  {path: 'subscriber/melodies', component: SubscriberMelodiesPageComponent, pathMatch: 'full', canActivate: [authGuard]},
  {path: 'subscriber/favorites', component: SubscriberFavoritesComponent, pathMatch: 'full', canActivate: [authGuard]},
  {path: 'subscriber/rules', component: SubscriberRulesPageComponent, pathMatch: 'full', canActivate: [authGuard]},
  {path: 'subscriber/ugc', component: SubscriberUgcPageComponent, pathMatch: 'full', canActivate: [authGuard]},
  {path: 'error/404', component: Page404Component, pathMatch: 'full'},
  {path: 'error/500', component: Page500Component, pathMatch: 'full'},
  {path: 'error/505', component: Page505Component, pathMatch: 'full'},
  {path: 'mobile-apps', component: MobileAppsPageComponent, pathMatch: 'full'},
  {path: 'ussd', component: UssdCommandsPageComponent, pathMatch: 'full'},
  {path: 'privacy', component: PrivacyPageComponent, pathMatch: 'full'},
  {path: 'offer', component: OfferPageComponent, pathMatch: 'full'},
  {path: '**', component: Page404Component}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
